import { HttpHeaders } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ExcelService } from '../../../services/excel/excel.service';
import { MayoresdepositantesService } from '../../../services/riesgo-liquidez/mayoresdepositantes.service';
import Swal from 'sweetalert2';
import { CommonVariables, FuncionesMes } from '../../funciones/funcionesGenerales';
import moment from 'moment';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { FiltersM, typesApex } from '../../../components/models';
import { messages } from '../../funciones/mensajes';

@Component({
  selector: 'app-mayores-depositantes',
  templateUrl: './mayores-depositantes.component.html',
  styleUrl: './mayores-depositantes.component.css'
})
export class MayoresDepositantesComponent {
  //---------------VARIABLES GENERALES
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  public colorMulti: any = ['#2843A0', '#15A075', '#36CAE8', '#78EAD2', '#F88476', '#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  public Filters = FiltersM;
  //-------------VARIABLES OBTENCION DE PERIODOS
  private numEvaluaciones = 1;
  private idPlantilla: number = 7;
  public encPar: number = 0;
  public pares = [0];
  public Periodos = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  //
  public limites = [];
  /*Filtros*/
  public cadenaEvaluacion = [];
  public miles = ',';
  public decimal = '.';
  //-------------VARIABLES DEL TABLERO
  public graftab1 = false; //mostrar el ampliar 
  public datos = [];
  public datosAT: any = [];
  public datosGraf: any = [];
  public datosGrafTab = [];
  public encPropVar = [];
  public dataPropVar = []
  public dataLim: any = []

  @ViewChild('graficador1') graficador1: GraficadorComponent;
  @ViewChild('graficador2') graficador2: GraficadorComponent;
  @ViewChild('graficador3') graficador3: GraficadorComponent;


  public tituloModal = '';
  public tipoGraf = 'bar';
  public tipoGraf2 = '';
  public tipoGraf3 = 'bar';
  public hori = true;
  public encNum = 10;
  public tabMay = false;
  public tabMayPrin = true;
  public tabMayPV = false;
  public vencido = true;

  // Variables para Gráfica 1 - Cartera/Stack
  public dataGrafica1: any[] = [];
  public labelsGrafica1: string[] = [];
  public tipoGrafica1 = typesApex.BAR;
  public ejesYGrafica1: string[] = ['%'];

  // Variables para Gráfica 2 - Mayores Depositantes
  public dataGrafica2: any[] = [];
  public labelsGrafica2: string[] = [];
  public tipoGrafica2 = typesApex.BARHORIZONTAL;
  public ejesYGrafica2: string[] = ['Saldo de ahorro'];
  public ejesXGrafica2: string = 'Núm. Socio';

  // Variables para Gráfica 3 - Proporción Variables
  public dataGrafica3: any[] = [];
  public labelsGrafica3: string[] = [];
  public tipoGrafica3 = typesApex.BAR;
  public ejesYGrafica3: string[] = ['%'];

  // Variables para control de etiquetas
  public etiquetas1 = false; // Gráfica 1: Cartera
  public etiquetas2 = false; // Gráfica 2: Mayores Depositantes
  public etiquetas3 = false; // Gráfica 3: Proporción Variables

  public modalOpen: boolean = false;

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private mayoresDepositantesService: MayoresdepositantesService
  ) {
    this.getEvaluacion();
  }
  ///----------FUNCIONES OBTENCION DE PERIODOS 
  //obtencion de periodos
  private async getEvaluacion() {
    try {
      const data = await this.mayoresDepositantesService.getPeriodosAT(this.headers, this.idPlantilla);
      this.ordenamientoDataEvaluacion([].concat(data.evaluaciones));
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  private ordenamientoDataEvaluacion(datos) {
    const info = CommonVariables.obtenerPeriodos(datos, this.numEvaluaciones);
    this.Periodos = info.periodos;
    for (const an of this.Periodos) {
      if (an.anio < 2023) {
        an.utilizable = false;
      }
    }
    this.obtenerDataEvaluacion();  
    this.getPropieties();       
  }
  private async getPropieties() {
    try {
      const periodoDinamico = this.cadenaEvaluacion[0]?.periodo || "2023-01";

      const data = await this.mayoresDepositantesService.getPropiedades(this.headers, "6463f46b5a452a0012fa8f38", periodoDinamico);

      const aditional = data.ahorros_sub_calculos?.adicionales || [];
      let auxLimits = []

      for (const periodos of aditional) {
        const fec = moment(periodos.periodo.split('T')[0]).format('DD-MM-YYYY');
        if (JSON.stringify(periodos.propiedades).includes('AHO')) {
          auxLimits.push({
            periodo: fec,
            limites: periodos.propiedades,
          });
        }
      }

      this.limites = auxLimits;

    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion() {
    this.cadenaEvaluacion = [];
    this.subTitles = "";
    var tot = 0;
    for (var i = this.Periodos.length - 1; i >= 0; i--) {
      for (var j = this.Periodos[i].series.length - 1; j >= 0; j--) {
        if (this.Periodos[i].series[j].check || (tot > 0 && tot < 12)) {
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            idEvaluacion: this.Periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos[i].series[j].pos,
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.getDatos();
  }

  /* formateo de datos */
  public escrituraPeriodo(Periodo) {
    if (Periodo.split(' ').length === 2) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    } else if (Periodo.split(' ').length === 5) {
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1] + ' ' + datos[2] + ' ' + this.translate.instant('filtros.' + datos[0]) + ' ' + datos[1];
    }
    return Periodo;
  }

  /*Formateo de cantidades recibe el numero a formatear 
  y true para decimales false sin decimales */
  public formatoNum(num, dec) {
    if (num !== undefined && num !== '') {
      return CommonVariables.formatearMoneda(num, dec, this.miles, this.decimal);
    }
    return '';
  }

  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per) {
    for (const an of this.Periodos) {
      for (const mes of an.series) {
        if (mes.periodo === per.periodo) {
          mes.check = true;
        } else {
          mes.check = false;
        }
      }
    }
    this.obtenerDataEvaluacion();
  }
  private async getDatos() {
    var auxTabla = [0, 0, 0, 0], valor = [0, 0];

    try {
      const data = await this.mayoresDepositantesService.getData(this.headers, this.cadenaEvaluacion[0].periodo);

      this.datosGraf = data.ahorros_sub_calculos.AHO_06;
      var d = data.ahorros_sub_calculos.AHO_06;
      valor[0] = data.ahorros_sub_calculos.AHO_07;
      valor[1] = data.ahorros_sub_calculos.AHO_08;

      // SUBCALCULOS TABLA PRINCIPAL
      var saldo = 0;
      for (let i = 0; i < d.length; i++) {
        saldo += (d[i].saldoGestionTotal + d[i].totalIntereses);
        if (i <= 9) {
          auxTabla[0] = saldo;
        }
        if (i <= 19) {
          auxTabla[1] = saldo;
        }
        if (i <= 49) {
          auxTabla[2] = saldo;
        }
        if (i <= 99) {
          auxTabla[3] = saldo;
        }
      }

      this.grafica(this.tipoGraf, this.hori, 10, this.tabMay);
      await this.getDatosAT(auxTabla, valor);

    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  public llenadoDatos(auxTabla, valor) {
    // LLENADO TABLA PRINCIPAL
    var aux = [];
    aux.push({
      id: "10Mayores",
      descripcion: "10 mayores depositantes",
      saldo: auxTabla[0] / 10,
      total: auxTabla[0],
      porcen: Math.abs(auxTabla[0] / this.datosAT.VT008),
      max: 0.13,
      rango: ''
    })
    aux.push({
      id: "20Mayores",
      descripcion: "20 mayores depositantes",
      saldo: auxTabla[1] / 20,
      total: auxTabla[1],
      porcen: Math.abs(auxTabla[1] / this.datosAT.VT008),
      max: 0.02,
      rango: ''
    })
    aux.push({
      id: "50Mayores",
      descripcion: "50 mayores depositantes",
      saldo: auxTabla[2] / 50,
      total: auxTabla[2],
      porcen: Math.abs(auxTabla[2] / this.datosAT.VT008),
      max: 0.20,
      rango: ''
    })
    aux.push({
      id: "100Mayores",
      descripcion: "100 mayores depositantes",
      saldo: auxTabla[3] / 100,
      total: auxTabla[3],
      porcen: Math.abs(auxTabla[3] / this.datosAT.VT008),
      max: 0.20,
      rango: ''
    })
    this.datos = aux;

    //LLENADO TABLA PROPORCION A VARIABLES
    this.encPropVar.push(this.datosAT.VT008);
    this.encPropVar.push(this.datosAT.VT042);

    var aux2 = [];
    aux2.push({
      id: "10Mayores",
      descripcion: "10 mayores depositantes",
      captaciones: this.datos[0].total / this.encPropVar[0],
      activos: this.datos[0].total / this.encPropVar[1],
    })
    aux2.push({
      id: "20Mayores",
      descripcion: "20 mayores depositantes",
      captaciones: this.datos[1].total / this.encPropVar[0],
      activos: this.datos[1].total / this.encPropVar[1],
    })
    aux2.push({
      id: "50Mayores",
      descripcion: "50 mayores depositantes",
      captaciones: this.datos[2].total / this.encPropVar[0],
      activos: this.datos[2].total / this.encPropVar[1],
    })
    aux2.push({
      id: "100Mayores",
      descripcion: "100 mayores depositantes",
      captaciones: this.datos[3].total / this.encPropVar[0],
      activos: this.datos[3].total / this.encPropVar[1],
    })
    this.dataPropVar = aux2;

    var aux3 = [];
    aux3.push({
      saldo: this.datosAT.VT017,
      valor: (valor[0].saldoGestion + valor[0].totalIntereses),
      porcen: (valor[0].saldoGestion + valor[0].totalIntereses) / this.datosAT.VT017
    });
    aux3.push({
      saldo: this.datosAT.VT050,
      valor: (valor[1].saldoGestion + valor[1].totalIntereses),
      porcen: (valor[1].saldoGestion + valor[1].totalIntereses) / this.datosAT.VT050
    });

    this.dataLim = aux3;
    this.graficaCartera(this.tipoGraf2, this.tabMayPrin);
    this.graficaProp(this.tipoGraf3, this.tabMayPV);
  }

  public rango(num, max) {
    if (num <= max) {
      return "w3-light-green2";
    } else {
      return "w3-orange2";
    }
  }
  public async getDatosAT(auxTabla, valor) {
    var vars = ["VT008", "VT042", "VT017", "VT050"]
    var auxAT = { VT008: 0, VT042: 0, VT017: 0, VT050: 0 }

    try {
      const historicalPromises = vars.map(p => {
        return this.mayoresDepositantesService.getATVarTemp(this.headers, this.cadenaEvaluacion[0].idEvaluacion, p);
      });

      const results = await Promise.all(historicalPromises);

      for (const data of results) {
        const { idVarTemp, valor: varValor } = data.detalleEvaluacionVarTemp;

        switch (idVarTemp) {
          case 'VT008': auxAT.VT008 = varValor; break;
          case 'VT042': auxAT.VT042 = varValor; break;
          case 'VT017': auxAT.VT017 = varValor; break;
          case 'VT050': auxAT.VT050 = varValor; break;
        }
      }

      this.datosAT = auxAT;
      this.llenadoDatos(auxTabla, valor);

    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }

  public grafica(tipo, eje, num, tab) {
    this.encNum = num;
    this.tipoGraf = tipo;
    this.hori = eje;
    this.tabMay = tab;

    if (!tab && num == 100) {
      this.encNum = 10;
      num = 10;
    }

    // Preparar datos para la tabla
    this.datosGrafTab = [];

    // Preparar datos para la gráfica
    this.labelsGrafica2 = [];
    const cantidades = [];

    const limit = num >= this.datosGraf.length ? this.datosGraf.length : num;

    for (let i = 0; i < limit; i++) {
      cantidades.push(this.datosGraf[i].saldoGestionTotal + this.datosGraf[i].totalIntereses);
      this.labelsGrafica2.push(this.datosGraf[i].numeroSocio);
      this.datosGrafTab.push(this.datosGraf[i]);
    }

    // Asignar datos al graficador
    this.dataGrafica2 = [{
      name: 'Saldo',
      data: cantidades
    }];

    // Determinar tipo de gráfica
    if (tipo === 'area') {
      this.tipoGrafica2 = typesApex.AREA;
    } else if (eje) {
      this.tipoGrafica2 = typesApex.BARHORIZONTAL;
    } else {
      this.tipoGrafica2 = typesApex.BAR;
    }
  }
  public graficaCartera(tipo, tab) {
    this.tabMayPrin = tab;
    this.tipoGraf2 = tipo;

    // Preparar labels
    this.labelsGrafica1 = ["10 mayores", "20 mayores", "50 mayores", "100 mayores"];

    // Preparar datos (porcentajes)
    const cantidades = this.datos.map(d => Number((d.porcen * 100).toFixed(1)));

    // Asignar datos al graficador
    this.dataGrafica1 = [{
      name: '% ',
      data: cantidades
    }];

    // Determinar tipo de gráfica
    if (tipo === 'bar') {
      this.tipoGrafica1 = typesApex.BAR;
    } else if (tipo === 'area') {
      this.tipoGrafica1 = typesApex.AREA;
    } else if (tipo === 'line') {
      this.tipoGrafica1 = typesApex.LINE;
    }
  }
  public graficaProp(tipo, tab) {
    this.tabMayPV = tab;
    this.tipoGraf3 = tipo;

    // Preparar labels
    this.labelsGrafica3 = ["10 mayores", "20 mayores", "50 mayores", "100 mayores"];

    // Preparar datos (dos series)
    const captaciones = this.dataPropVar.map(d => Number((d.captaciones * 100).toFixed(1)));
    const activos = this.dataPropVar.map(d => Number((d.activos * 100).toFixed(1)));

    // Asignar datos al graficador
    this.dataGrafica3 = [
      { name: '% Captaciones', data: captaciones },
      { name: '% Activos líquidos', data: activos }
    ];

    // Determinar tipo de gráfica
    if (tipo === 'bar') {
      this.tipoGrafica3 = typesApex.BAR;
    } else if (tipo === 'area') {
      this.tipoGrafica3 = typesApex.AREA;
    } else if (tipo === 'line') {
      this.tipoGrafica3 = typesApex.LINE;
    }
  }

  //ampliar la grafica 
  public ampliarGraf(grafZona) {
    this.tituloModal = grafZona;
    this.modalOpen = true;
  }
  /* Actualizar limites */
  public async actualizarLimits(prop, limite) {
    var inputValue = this.obtLimitO(prop, limite);
    var introdujo: any, guardo = false;

    let texto = '';
    if (limite === 'min') {
      texto = 'mínimo';
    } else {
      texto = 'máximo';
    }

    introdujo = await Swal.fire({
      title: 'Ingresa el procentaje ' + texto,
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('swal.acep'),
      cancelButtonText: this.translate.instant('swal.cerr'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (Number(value) > 100) {
          return 'El porcentaje no puede exceder el 100%';
        }
        guardo = true;
        return '';
      }
    });

    if (guardo) {
      this.obtLimitesArreglo(prop, limite, introdujo.value);
    } else {
      messages.errorMessageGraph(this.translate.instant('swal.swalNoGuardo'));
    }
  }
  // Limites aho 6
  private async obtLimitesArreglo(i, limite, valor) {
    let lim = this.obtLimitJson();
    let nuevoPerido = false;
    var periodo = moment(FuncionesMes.escrituraPer(this.subTitles)).format('YYYY-MM'), Json;

    var pers = 'AHO_06';


    if (lim !== undefined) {
      let nuevo = JSON.parse(JSON.stringify(lim.limites));
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(limite, i, valor, undefined) + ' }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse(this.obtenerArrayLim(limite, i, valor, nuevo[pers]));
        nuevo[pers] = nnn;
      }
      lim.limites = nuevo;
      Json = nuevo;
    } else {
      const cop = this.obtLimitJsonCopia();
      let nuevo;
      if (cop !== undefined) {
        nuevo = JSON.parse(JSON.stringify(cop.limites));
      } else {
        nuevo = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(limite, i, valor, undefined) + ' }');
      }
      /* --------------- */
      if (nuevo[pers] === undefined) {
        let n = JSON.parse('{ "' + pers + '": ' + this.obtenerArrayLim(limite, i, valor, undefined) + ' }');
        nuevo = Object.assign(n, nuevo);
      } else {
        let nnn = JSON.parse(this.obtenerArrayLim(limite, i, valor, nuevo[pers]));
        nuevo[pers] = nnn;
      }
      nuevoPerido = true;
      Json = nuevo;

    }
    try {
      await this.mayoresDepositantesService.setLimites(this.headers, periodo, Json, "6463f46b5a452a0012fa8f38");

      if (nuevoPerido) {
        this.limites.push({
          periodo: moment(periodo + '-01', "YYYY-MM-DD").format("DD-MM-YYYY"),
          limites: Json
        });
      }
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    } catch (error) {
      messages.errorMessageGraph(error);
    }
  }
  private obtenerArrayLim(lim, dat, valor, info) {
    let perspec = [];
    if (info === undefined) {
      perspec.push({
        descripcion: dat.id,
        limits: {
          max: 0,
          min: 0
        }
      });
    } else {
      let d = info.filter(d => d.descripcion === dat.id);
      perspec = JSON.parse(JSON.stringify(info));
      if (d.length === 0) {
        perspec.push({
          descripcion: dat.id,
          limits: {
            max: 0,
            min: 0
          }
        });
      }
    }
    let ex = perspec.filter(d => d.descripcion === dat.id);
    ex[0]['limits'][lim] = Number(valor);
    return JSON.stringify(perspec);
  }
  /* Limites */
  public obtLimitO(prop, lim, form?) {
    let auxLimits = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        auxLimits = p;
        if (auxLimits === undefined) {
          auxLimits = p;
        } else if (moment(auxLimits.periodo).isBefore(moment(p.periodo))) {
          auxLimits = p;
        }
      }
    }

    if (!auxLimits) {
      return 0;
    }

    if (auxLimits.limites['AHO_06']) {
      let d = auxLimits.limites['AHO_06'].filter(d => d.descripcion === prop.id);
      if (d.length !== 0) {
        if (form === undefined) {
          return this.formatoNum(d[0].limits[lim], true);
        } else {
          return d[0]['limits'][lim];
        }
      } else {
        return 0;
      }
    }

    return 0;
  }
  /* En rango */
  public enRango(i) {
    const max = this.obtLimitO(i, 'max', '');
    if (0 !== max) {
      if ((i.porcen * 100) <= max) {
        //el monto sobrepasa el maximo establecido
        return "check_circle";
      } else {
        //el monto esta en rango 
        return "cancel";
      }
    } else {
      //limites incongruentes
      return "help";
    }
    return "help";
  }
  //obtiene el arreglo de limites del periodo
  public obtLimitJson() {
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSame(pS)) {
        return p;
      }
    }
    return undefined;
  }
  public obtLimitJsonCopia() {
    let exis = undefined;
    for (const p of this.limites) {
      const pS = moment(FuncionesMes.escrituraPer(this.subTitles), 'DD/MM/YY');
      if (moment(p.periodo).isSameOrBefore(pS)) {
        if (exis === undefined) {
          exis = p;
        } else if (moment(exis.periodo).isSameOrBefore(moment(p.periodo))) {
          exis = p;
        }
      }
    }
    return exis;
  }

  public exportMayoresDepo() {
    var tit = [], datos = [];

    tit.push(this.translate.instant('liquidez.mayores.tit3'));
    tit.push(this.translate.instant("liquidez.mayores.tit4"));
    tit.push(this.translate.instant("liquidez.mayores.tit5"));
    tit.push(this.translate.instant("liquidez.mayores.tit6"));

    let j = 1;
    for (const i of this.datosGrafTab) {
      var aux = [];
      aux.push(j);
      aux.push(i.numeroSocio);
      aux.push(i.cuentaAhorro);
      aux.push((i.saldoGestionTotal + i.totalIntereses));
      datos.push(aux)
      j++;
    }

    let titHoja = this.encNum + " " + this.translate.instant('liquidez.mayores.tituloGraf') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelLiquidezMayores(titHoja, tit, datos, this.encNum + ' ' + this.translate.instant('liquidez.mayores.tituloGraf') + " " + this.escrituraPeriodo(this.subTitles));
  }

  public exportCartera() {
    var tit = [], enc = [], datos = [], rango = [];

    tit.push('');
    tit.push('');
    tit.push(this.translate.instant('liquidez.mayores.tit1'));
    tit.push('');
    tit.push('');
    tit.push(this.translate.instant('liquidez.mayores.tit2'));

    enc.push(this.translate.instant('liquidez.mayores.enc1'));
    enc.push(this.translate.instant("liquidez.mayores.enc2"));
    enc.push(this.translate.instant('liquidez.mayores.enc5'));
    enc.push(this.translate.instant("liquidez.mayores.enc6"));
    enc.push(this.translate.instant("liquidez.mayores.enc8"));
    enc.push(this.translate.instant("liquidez.mayores.enc9"));

    let j = 1;
    for (const i of this.datos) {
      var aux = [];
      aux.push(i.descripcion);
      aux.push(i.saldo);
      aux.push(i.total);
      aux.push(i.porcen);
      aux.push(i.max);
      aux.push(i.rango);
      rango.push(this.rango(i.porcen, i.max))
      datos.push(aux)
      j++;
    }
    let titHoja = this.translate.instant('liquidez.mayores.tituloTabla') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelLiquidezCarteraMay(titHoja, tit, enc, datos, this.translate.instant('liquidez.mayores.tituloTabla') + " " + this.escrituraPeriodo(this.subTitles), rango);
  }

  public exportPV() {
    var tit = [], enc = [], datos = [];

    tit.push('');
    tit.push(this.translate.instant('liquidez.mayores.enc10'));
    tit.push(this.translate.instant('liquidez.mayores.enc11'));

    enc.push(this.translate.instant('liquidez.mayores.enc1'));
    enc.push(this.encPropVar[0]);
    enc.push(this.encPropVar[1]);

    for (const i of this.dataPropVar) {
      var aux = [];
      aux.push(i.descripcion);
      aux.push(i.captaciones);
      aux.push(i.activos);
      datos.push(aux)
    }
    let titHoja = this.translate.instant('liquidez.mayores.titulotab1') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelCreditoPropVar(titHoja, tit, enc, datos, this.translate.instant('liquidez.mayores.titulotab1') + " " + this.escrituraPeriodo(this.subTitles));
  }

  public exportLim() {
    var tit = [], datos = [];

    tit.push(this.translate.instant('credito.mayores.enc1'));
    tit.push(this.translate.instant('credito.mayores.enc12'));
    tit.push(this.translate.instant('credito.mayores.enc13'));
    tit.push(this.translate.instant('credito.mayores.enc14'));

    var aux = [];
    aux.push("Monto más alto de captaciones a la vista");
    aux.push(this.dataLim[0].saldo);
    aux.push(this.dataLim[0].valor);
    aux.push(this.dataLim[0].porcen);
    datos.push(aux);
    aux = [];
    aux.push("Monto más alto de depósitos a plazos");
    aux.push(this.dataLim[1].saldo);
    aux.push(this.dataLim[1].valor);
    aux.push(this.dataLim[1].porcen);
    datos.push(aux);
    let titHoja = this.translate.instant('liquidez.mayores.titulotab2') + " | " + this.escrituraPeriodo(this.subTitles);
    this.exportExcel.excelLiquidezLimites(titHoja, tit, datos, this.translate.instant('liquidez.mayores.titulotab2') + " " + this.escrituraPeriodo(this.subTitles));
  }

  // Métodos para exportar gráficas
  public exportarGrafica1() {
    const titulos = {
      titulo: this.translate.instant('liquidez.mayores.tituloTabla'),
      subtitulo: this.escrituraPeriodo(this.subTitles),
      nombreArch: 'Cartera_Depositantes_' + this.escrituraPeriodo(this.subTitles)
    };

    if (this.graficador1) {
      this.graficador1.exportImg(1, titulos);
    }
  }

  public exportarGrafica2() {
    const titulos = {
      titulo: this.encNum + ' ' + this.translate.instant('liquidez.mayores.tituloGraf'),
      subtitulo: this.escrituraPeriodo(this.subTitles),
      nombreArch: this.encNum + '_Mayores_Depositantes_' + this.escrituraPeriodo(this.subTitles)
    };

    if (this.graficador2) {
      this.graficador2.exportImg(2, titulos);
    }
  }

  public exportarGrafica3() {
    const titulos = {
      titulo: this.translate.instant('liquidez.mayores.titulotab1'),
      subtitulo: this.escrituraPeriodo(this.subTitles),
      nombreArch: 'Proporcion_Variables_' + this.escrituraPeriodo(this.subTitles)
    };

    if (this.graficador3) {
      this.graficador3.exportImg(3, titulos);
    }
  }

  // Exportar gráfica desde el modal ampliado
  public exportarGraficaModal() {
    if (this.tituloModal === 'prin') {
      const titulos = {
        titulo: this.translate.instant('liquidez.mayores.tituloTabla'),
        subtitulo: this.escrituraPeriodo(this.subTitles),
        nombreArch: 'Cartera_Depositantes_' + this.escrituraPeriodo(this.subTitles)
      };
      if (this.graficador1) {
        this.graficador1.exportImg(4, titulos);
      }
    } else if (this.tituloModal === 'may') {
      const titulos = {
        titulo: this.encNum + ' ' + this.translate.instant('liquidez.mayores.tituloGraf'),
        subtitulo: this.escrituraPeriodo(this.subTitles),
        nombreArch: this.encNum + '_Mayores_Depositantes_' + this.escrituraPeriodo(this.subTitles)
      };
      if (this.graficador2) {
        this.graficador2.exportImg(5, titulos);
      }
    } else if (this.tituloModal === 'pv') {
      const titulos = {
        titulo: this.translate.instant('liquidez.mayores.titulotab1'),
        subtitulo: this.escrituraPeriodo(this.subTitles),
        nombreArch: 'Proporcion_Variables_' + this.escrituraPeriodo(this.subTitles)
      };
      if (this.graficador3) {
        this.graficador3.exportImg(6, titulos);
      }
    }
  }
}
